export default "__VITE_ASSET__e138f4ae__"